import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import capitalMarketsService from '../services/capitalMarketsService';

export default function useAddFinancingsToCession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      cessionId,
      solfacilFinancingIds,
    }: {
      cessionId: number;
      solfacilFinancingIds: number[];
    }) => capitalMarketsService.addFinancingsToCession(cessionId, solfacilFinancingIds),
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Erro ao adicionar financiamentos à cessão';
      toast.error(errorMessage);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cession', 'detail'] });
      queryClient.invalidateQueries({ queryKey: ['cessions'] });
    },
  });
}
